import { Injectable } from '@angular/core';
import { FirebaseApp } from 'angularfire2';
import * as firebase from 'firebase';

@Injectable()
export class FirebaseService {
  private message: string;
  private date: Date;
  user: any;

  constructor(public firebaseApp: FirebaseApp) {}

  /**
  setDate() {
    this.date = new Date();
    this.message = this.date.toString();
  }

  upLoadArchivoLog(message) {
    this.message = this.message + ' ' + '\r\n' + message;
    let storageRef = this.firebaseApp.storage().ref();
    let fileRef = storageRef.child(`log/${this.date}.txt`);
    fileRef.putString(this.message).then(snapshot => {});
  }
 */

  updateUserAddresData(uid, address) {
    this.readUserData(uid).then(snapshot => {
      if (snapshot.val()) {
        this.user = snapshot.val();
        this.user.address = address;
        this.writeUser(this.user);
      }
    });
  }

  readUserData(uid) {
    return firebase
      .database()
      .ref('/users/' + uid)
      .once('value');
  }

  writeUser(user) {
    firebase
      .database()
      .ref('users/' + user.uid)
      .set(user);
  }
}



// WEBPACK FOOTER //
// ./src/services/firebase.service.ts